import { ComponentWithAs, IconProps } from '@chakra-ui/react';

import { FolderIcon } from '../../../assets/icons/FolderIcon';
import { HomeIcon } from '../../../assets/icons/HomeIcon';

type SubItem = {
  id: number;
  title: string;
  href: string;
};

export type MenuItem = {
  id: number;
  title: string;
  icon: ComponentWithAs<'svg', IconProps>;
  subItems: SubItem[];
};

export const menuItems: MenuItem[] = [
  {
    id: 1,
    title: 'Oportunidade SulAmérica',
    icon: HomeIcon,
    subItems: [
      { id: 1, title: 'Meu novo site', href: '/corretor/white-label/painel' },
      { id: 2, title: 'Gestão de leads', href: '/corretor/leads' }
    ]
  },
  {
    id: 2,
    title: 'Gestão de Carteira',
    icon: FolderIcon,
    subItems: [
      { id: 1, title: 'Gestão de Carteira', href: '/corretor/gestao-carteira' },
      {
        id: 2,
        title: 'Painel de vendas contrata fácil',
        href: '/corretor/vida-individual/painel-vendas-contrata-facil'
      },
      {
        id: 3,
        title: 'Carteira vida',
        href: '/corretor/vida-individual/carteira-vida'
      },
      {
        id: 4,
        title: 'Carteira previdência',
        href: '/corretor/previdencia-individual/carteira-previdencia'
      },
      {
        id: 5,
        title: 'Resgates (consulta)',
        href: '/corretor/previdencia-individual/consulta-resgates'
      },
      {
        id: 7,
        title: 'SOS Prev (consulta)',
        href: '/corretor/previdencia-individual/sos-prev'
      },
      {
        id: 8,
        title: 'Carteira Recomendada',
        href: '/corretor/previdencia-individual/carteira-recomendada'
      },
      {
        id: 9,
        title: 'Realizar Movimentação Entre Fundos',
        href: '/corretor/previdencia-individual/movimentacao-fundos/base-clientes'
      },
      {
        id: 10,
        title: 'Carteira Viagem',
        href: '/corretor/viagem/carteira-viagem'
      }
    ]
  }
];
